module.exports = __webpack_public_path__ + "static/media/calculator.97daea68.png";